import React from "react";
import "../ConfirmPopup/ConfirmPopup.css";
import CancelBtn from "../CustomButtons/CancelBtn/CancelBtn";

interface ConfirmPopupProps {
  isOpen: boolean;
  title?: string;
  message?: React.ReactNode;   
  onConfirm: () => void;
  onCancel: () => void;
  onSave?: () => void;
  confirmLabel?: string;
  cancelLabel?: string;
  saveLabel?: string;
  confirmColor?: string;
  cancelColor?: string;
  saveColor?: string;
  confirmDisabled?: boolean;
  saveDisabled?: boolean;
  blur?: boolean;
}

const ConfirmPopup: React.FC<ConfirmPopupProps> = ({
  isOpen,
  title = "Confirmation",
  message = "Are you sure?",
  onConfirm,
  onCancel,
  onSave,
  confirmLabel = "Yes",
  cancelLabel = "No",
  saveLabel = "Save",
  confirmColor = "#e53e3e",
  cancelColor,
  saveColor = "var(--color-brand)",
  confirmDisabled = false,
  saveDisabled = false,
  blur = false,
}) => {
  if (!isOpen) return null;

  return (
    <div className={`popup-overlay${blur ? " popup-overlay--blur" : ""}`}>
      <div className={`popup-box${onSave ? " popup-box--with-save" : ""}`}>
        <div className="popup-header">
          <h3>
            {onSave && <span className="popup-warning-icon" aria-hidden="true">!</span>}
            {title}
          </h3>
          <CancelBtn CancelBtnClick={onCancel} closeButon={confirmDisabled} />
        </div>

        <div className="popup-body">
          <p>{message}</p>
        </div>

        <div className="popup-footer">
          <button
            className="cancel-btn"
            onClick={onCancel}
            disabled={confirmDisabled}
            style={cancelColor ? { backgroundColor: cancelColor } : undefined}
          >
            {cancelLabel}
          </button>
          <button
            className="confirm-btn"
            onClick={onConfirm}
            disabled={confirmDisabled}
            style={{ backgroundColor: confirmColor }}
          >
            {confirmLabel}
          </button>
          {onSave && (
            <button
              className="confirm-btn popup-save-btn"
              onClick={onSave}
              disabled={confirmDisabled || saveDisabled}
              style={{ backgroundColor: saveColor }}
            >
              {saveLabel}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfirmPopup;
